import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { useSessionDataEpoch } from '@/lib/sessionData';
import type { HouseholdContact } from '@shared/types';

export function useContacts() {
  const [contacts, setContacts] = useState<HouseholdContact[]>([]);
  const [loading, setLoading] = useState(true);
  const sessionEpoch = useSessionDataEpoch();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get<{ contacts: HouseholdContact[] }>('/contacts')
      .then((res) => {
        if (!cancelled) setContacts(res.contacts);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [sessionEpoch]);

  return { contacts, loading };
}
